import type { Chip } from "../core/chip";

type Props = { chip: Chip; onInvoke: () => void };

export function ChipSheet({ chip, onInvoke }: Props) {
  return (
    <aside class="bottom-sheet" aria-label={`${chip.title} details`}>
      <span class="sheet-grab" aria-hidden="true" />
      <div class="chip-sheet-head">
        <div class="chip-id">{chip.id.toUpperCase()}</div>
        <div class="chip-id">REV {chip.revision}</div>
      </div>
      <h2>
        {chip.title === "CPU-001" ? "Game Two CPU Encounter" : chip.title}
      </h2>
      <div class="bottom-grid">
        <div>
          <div class="meta">GOAL</div>
          <p>{chip.goal ?? "NONE"}</p>
        </div>
        <div>
          <div class="meta">TRUTH</div>
          <p>{chip.truth}</p>
        </div>
        <div>
          <div class="meta">RISK</div>
          <p class="risk-clear">{chip.risk}</p>
        </div>
      </div>
      <button class="invoke-button" onClick={onInvoke}>
        INVOKE
      </button>
    </aside>
  );
}
